import { CONTRACTS_TYPES } from '../../utils/Constants';

interface TemplateItem {
  id: string;
  label: string;
}

interface SignerLike {
  signer_type_code: string | string[];
}

export const getAvailableSignerTypes = (signers: SignerLike[]): string[] =>
  signers.flatMap((signer) =>
    Array.isArray(signer.signer_type_code)
      ? signer.signer_type_code
      : [signer.signer_type_code]
  );

export const filterTemplatesBySigners = (
  templates: TemplateItem[],
  signers: SignerLike[]
): TemplateItem[] => {
  const availableSignerTypes = getAvailableSignerTypes(signers);
  return templates.filter((template) => {
    const contractType = CONTRACTS_TYPES.find(
      (type) => type.label === template.label
    );
    return contractType && availableSignerTypes.includes(contractType.id);
  });
};
